import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import template from './owner-updater-step2.hbs'
import selects from 'scoreboard/components/selects'
import assignLinkGroups from 'scoreboard/components/assign-link-groups'
import PrincipalFilter from '../../common/filter/principal-filter'

function updatePrincipal(filters, principals = {}, type, linkGroup) {
	let filterValue = [_.assign({operator: 'contains-any'}, principals)]
	if (type == 'updater') {
		filters.updaters = filterValue
		delete filters.owners
	} else if (type == 'owner') {
		filters.owners = filterValue
		delete filters.updaters
	} else {
		filterValue[0].linkGroup = linkGroup
		filters.updaters = filterValue
		//concat so that each filter has a different array reference, otherwise deletion
		//of one will affect the other
		filters.owners = [].concat(filterValue)
	}
}

export default Backbone.View.extend({

	className: 'owner-updater-step2',

	events: {
		'change input[type=checkbox]': 'updateDisplayOptions',
		'change select[name=type]': 'updateType'
	},

	initialize: function(options) {
		const principals = _.get(this.model.get('filters'), 'owners[0]', {})
		this.principalsPanel = new PrincipalFilter({
			assigneesInfo: {
				heading: i18n.get('report.ownerUpdaterReport.form.user'),
				placeholder: i18n.get('report.ownerUpdaterReport.anyUser')
			},
			orgId: this.model.get('organizationId'),
			data: _.cloneDeep(principals)
		})

		this.linkGroup = assignLinkGroups(_.flatMap(this.model.get('filters')))

		this.listenTo(this.principalsPanel, 'change', () => {
			const filters = _.cloneDeep(this.model.get('filters'))
			const principal = this.principalsPanel.gather()
			const type = this.$('select[name=type]').val()
			updatePrincipal(filters, principal, type, this.linkGroup)
			this.model.set('filters', filters)
		})
	},

	render: function() {
		this.$el.html(template())
		this.$('.principals').replaceWith(this.principalsPanel.el)
		this.principalsPanel.render()
		selects(this.$('select'))
		return this
	},

	_toggleColumnOfType(columnType, shouldBeThere) {
		const currIndex = this.model.stacks().findIndex(stack => {
			return stack.columns().find(col => col.get('columnType') === columnType)
		})
		const alreadyThere = !!currIndex

		if (shouldBeThere && !alreadyThere) {
			this.model.addStack(null, columnType)
		} else if (!shouldBeThere && alreadyThere) {
			this.model.removeStack(currIndex)
		}
	},

	updateType: function(e) {
		const filters = _.cloneDeep(this.model.get('filters'))
		const principal = this.principalsPanel.gather()
		const type = $(e.target).val()

		updatePrincipal(filters, principal, type, this.linkGroup)

		let toggleOwners = true
		let toggleUpdaters = true
		if (type == 'owner') {
			toggleUpdaters = false
		} else if (type == 'updater') {
			toggleOwners = false
		}

		this._toggleColumnOfType('owners', toggleOwners)
		this._toggleColumnOfType('updaters', toggleUpdaters)

		this.model.set('filters', filters)
	},

	updateDisplayOptions: function(e) {
		//this options does not need validation so we don't have to trigger anything
		const filters = this.model.get('filters')
		if ($(e.target).val()) {
			filters.types = [{values:['metric']}]
		} else {
			delete filters.types
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.principalsPanel], 'remove')
	}

})
